import { RouteObject } from 'react-router-dom'

import PrivateRoute from 'component/common/private-route'
import { FEATURE } from 'constants/feature'
import AccountVestingHMC from 'pages/account-vesting/account-vesting-hmc'
import AccountVestingHMCV2 from 'pages/account-vesting/account-vesting-hmc-v2'
import AccountVestingVenture from 'pages/account-vesting/account-vesting-venture'
import AccountVestingVentureV2 from 'pages/account-vesting/account-vesting-venture-v2'
import Vesting from 'pages/vesting'
import VestingHMC from 'pages/vesting/vesting-hmc'
import VestingHMCV2 from 'pages/vesting/vesting-hmc-v2'
import VestingVenture from 'pages/vesting/vesting-venture'
import VestingVentureV2 from 'pages/vesting/vesting-venture-v2'
import { PAGES } from 'routes/index'

export const vestingRoutes: RouteObject[] = [
  {
    path: PAGES.VESTING,
    element: (
      <PrivateRoute feature={FEATURE.VESTING}>
        <Vesting />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.VESTING_HMC,
    element: (
      <PrivateRoute feature={FEATURE.VESTING}>
        <VestingHMC />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.VESTING_VENTURE,
    element: (
      <PrivateRoute feature={FEATURE.VESTING}>
        <VestingVenture />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.VESTING_HMC_V2,
    element: (
      <PrivateRoute feature={FEATURE.VESTING}>
        <VestingHMCV2 />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.VESTING_VENTURE_V2,
    element: (
      <PrivateRoute feature={FEATURE.VESTING}>
        <VestingVentureV2 />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.ACCOUNT_VESTING_HMC,
    element: (
      <PrivateRoute feature={FEATURE.ACCOUNT_VESTING}>
        <AccountVestingHMC />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.ACCOUNT_VESTING_VENTURE,
    element: (
      <PrivateRoute feature={FEATURE.ACCOUNT_VESTING}>
        <AccountVestingVenture />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.ACCOUNT_VESTING_HMC_V2,
    element: (
      <PrivateRoute feature={FEATURE.ACCOUNT_VESTING}>
        <AccountVestingHMCV2 />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.ACCOUNT_VESTING_VENTURE_V2,
    element: (
      <PrivateRoute feature={FEATURE.ACCOUNT_VESTING}>
        <AccountVestingVentureV2 />
      </PrivateRoute>
    ),
  },
]
